import React from 'react';
import { useFormContext } from 'react-hook-form';

import { Box } from '@mui/material';

import { RadioControlled } from 'components/_basic/Form/Radio';
import { CurrencyUnitSelector } from 'components/BusinessToolForm/components/CurrencyUnitSelector/CurrencyUnitSelector';
import { useGetPeriodOptions } from 'components/BusinessToolForm/constants/periods';
import { GLOBAL_PERIOD_NAME } from 'components/BusinessToolForm/Sections/Global/form';

import { concatWithDot } from 'helpers/string';

import { IProjectedCashFlowHeaderProps } from './types';
import { PROJECTED_CASH_FLOW_FORM_NAMES, projectedCashFlowPrefix } from '../../utils/form';

import styles from './ProjectedCashFlowHeader.module.scss';

export const ProjectedCashFlowHeader: React.FC<IProjectedCashFlowHeaderProps> = ({ disabled }) => {
  const { control } = useFormContext();
  const periodOptions = useGetPeriodOptions();

  return (
    <Box className={styles.header}>
      <RadioControlled
        id="profitabilityFormHeader.period"
        name={GLOBAL_PERIOD_NAME}
        control={control}
        options={periodOptions}
        disabled={disabled}
      />

      <CurrencyUnitSelector
        name={concatWithDot(projectedCashFlowPrefix, PROJECTED_CASH_FLOW_FORM_NAMES.CURRENCY)}
        disabled={disabled}
      />
    </Box>
  );
};
